module.exports = __webpack_public_path__ + "img/_santander.png";